<template>
  <div class="col-sm-8">
    <span class="text-center">
      <h1>Leandro Gomez</h1>
      <h3 class="text-muted">Full Stack Sofware Developer</h3>
    </span>
    <br/>
    <span style="font-size: 20px;">
      <p>
        Hello there, I'm a software developer at <a class="text-info" target="__blank" href="https://devartis.com/">devartis SA</a>, but ready to start your project!
        I have several years of experience in Backend development with <a class="text-info" href="https://www.djangoproject.com/" target="__blank">Django</a>, <a class="text-info" href="https://www.ansible.com/" target="__blank">Ansible</a> and <a class="text-info" href="https://www.docker.com/" target="__blank">Docker</a>.
        Whenever I can, I like learning some cloud techologies like <a class="text-info" href="https://kubernetes.io/" target="__blank">Kubernetes</a> and <a class="text-info" href="https://aws.amazon.com/" target="__blank">AWS</a>.
      </p>
      <p>
        In my free time I like playing the guitar and travelling.
        My perfect place in the world is with my wife, my guitar and some Fernet at the beach.
      </p>
      <p>
        Don't hesitate to reach me out if you have any ideas We can work together.
      </p>
    </span>
    <div class="btn-group mt-1">
      <a href="/#/gists" class="btn btn-outline-info">Gists <i class="fab fa-github"></i></a>
      <a href="/#/repos" class="btn btn-outline-info">Repositories <i class="fab fa-github"></i></a>
      <a href="/#/books" class="btn btn-outline-info">Fav. Books <i class="fas fa-journal-whills"></i></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PresentationCard'
}
</script>
